
export function downloadCsv( filename: string, headers: string[], rows: ( string | number | undefined )[][] ): void {
    const csvContent = [
        headers.join( "," ),
        ...rows.map( row => row.map( cell => cell ?? "N/A" ).join( "," ) )
    ].join( "\n" );    
    const      blob = new                     Blob( [csvContent], { type: "text/csv" } );
    const      url  = URL.createObjectURL(    blob  );
    const      a    = document.createElement( "a"   );
    a.href     =    url;
    a.download =    filename;
    a.click();
    URL.revokeObjectURL(url);
}